import { render } from "./question-result-gap-card.vue?vue&type=template&id=569b8c08&ts=true"
import script from "./question-result-gap-card.vue?vue&type=script&lang=ts"
export * from "./question-result-gap-card.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__